export const generateQueueToListen = (agentId) => {
  const uniqueid =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
  const hash = uniqueid.toUpperCase();
  return `AGENT-${agentId}-${Date.now()}`;
};
